import {KN15ParseService} from './kn15-telegram/kn15-parse.service';
import {OperationalInputService} from './input.service';
import {DailyDataService} from './daily-data.service';
import {TelegramDataComparisonService} from './telegram-data-comparison.service';
import curveComponent from './curve.component';
import inputComponent from './input.component';
import saveComponent from './save.component';
import telegramComponent from './telegram.component';
import dataOverviewComponent from './data-overview.component';
import dataProcessingComponent from './data-processing.component';
import waterLevelCardComponent from './kn15-telegram/water-level-card.component';
import dischargeCardComponent from './kn15-telegram/discharge-card.component';
import icePhenomenaCardComponent from './kn15-telegram/ice-phenomena-card.component';
import temperatureCardComponent from './kn15-telegram/temperature-card.component';
import meteoCardComponent from './kn15-telegram/meteo-card.component';
import {
    icePhenomenaCodeFormatterFactory,
    icePhenomenaIntensityFormatterFactory
} from './kn15-telegram/ice-phenomena';
import curveCreatorComponent from './curve-creator.component';
import kn15ParseValidatorFactory from './kn15-telegram/kn15-parse-validator.directive';

export default angular.module('imomo.operational.input', [])
    .component('imomoOperationalInput', inputComponent)
    .component('imomoOperationalInputTelegram', telegramComponent)
    .component('imomoOperationalInputDataOverview', dataOverviewComponent)
    .component('imomoOperationalInputDataProcessing', dataProcessingComponent)
    .component('imomoOperationalInputCurve', curveComponent)
    .component('imomoOperationalInputSave', saveComponent)
    .component('imomoOperationalInputWaterLevelCard', waterLevelCardComponent)
    .component('imomoOperationalInputDischargeCard', dischargeCardComponent)
    .component('imomoOperationalInputIcePhenomenaCard', icePhenomenaCardComponent)
    .component('imomoOperationalInputTemperatureCard', temperatureCardComponent)
    .component('imomoOperationalInputMeteoCard', meteoCardComponent)
    .component('imomoOperationalInputCurveCreator', curveCreatorComponent)
    .service('kn15ParseService', KN15ParseService)
    .service('operationalInputService', OperationalInputService)
    .service('dailyDataService', DailyDataService)
    .service('telegramDataComparisonService', TelegramDataComparisonService)
    .filter('icePhenomenaCodeFormatter', icePhenomenaCodeFormatterFactory)
    .filter('icePhenomenaIntensityFormatter', icePhenomenaIntensityFormatterFactory)
    .directive('kn15ParseValidator', kn15ParseValidatorFactory)
    .name;



/** WEBPACK FOOTER **
 ** ./app/operational/input/input.module.ts
 **/